<script>
  import { Line } from 'vue-chartjs';

  export default {
    name: 'PerformanceChart',
    extends: Line,
    props: {
      chartData: {
        type: Object,
        required: true
      },
      timeUnit: {
        type: String,
        default: () => 'hour'
      },
      timeUnitStepSize: {
        type: Number,
        default: () => 2
      },
      timeUnitMin: {
        type: Number,
        default: () => null
      }
    },
    data() {
      return {
        options: {
          legend: {
            display: false
          },
          chartArea: {
            backgroundColor: 'rgba(251, 85, 85, 0.4)'
          },
          scales: {
            xAxes: [
              {
                type: 'time',
                time: {
                  unit: this.timeUnit,
                  unitStepSize: this.timeUnitStepSize,
                  displayFormats: {
                    millisecond: 'MMM DD',
                    second: 'MMM DD',
                    minute: 'MMM DD',
                    hour: 'HH:mm',
                    day: 'DD MMM YY',
                    week: 'MMM DD',
                    month: 'MMM DD',
                    quarter: 'MMM DD',
                    year: 'MMM DD'
                  },
                  tooltipFormat: 'MMM DD YYYY HH:mm'
                },
                ticks: {
                  min: this.timeUnitMin
                },
                gridLines: {
                  display: true,
                  color: '#bfbfbf'
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                },
                gridLines: {
                  display: true
                }
              }
            ]
          },
          elements: {
            line: {
              fill: false,
              tension: 0
            }
          },
          responsive: true,
          maintainAspectRatio: false
        }
      };
    },
    mounted() {
      this.renderChart(this.chartData, this.options);
    },
    methods: {}
  };
</script>

<style></style>
